import { AnimatePresence, motion } from "motion/react";
import styled from "@emotion/styled";
import { FC } from "react";
import { MDSProgressBar, MDSProgressBarColor } from "@/mds";

interface Props {
  active: boolean;
  color?: string;
  inset?: number;
  isChatOverlayOpen?: boolean;
}

export const SidePanelLoaderBar: FC<Props> = ({
  active,
  inset = 16,
  isChatOverlayOpen = false,
}) => {
  return (
    <OuterWrapper inset={inset}>
      <AnimatePresence>
        {active && (
          <motion.div
            key="sidepanel-loader"
            initial={{ opacity: 0, y: -2 }}
            animate={{ opacity: isChatOverlayOpen ? 0 : 1, y: 0 }}
            exit={{ opacity: 0, y: -2 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
          >
            <InnerWrapper>
              <MDSProgressBar color={MDSProgressBarColor.Brand} isIndeterminate />
            </InnerWrapper>
          </motion.div>
        )}
      </AnimatePresence>
    </OuterWrapper>
  );
};

interface OuterWrapperProps {
  inset: number;
}

const OuterWrapper = styled.div<OuterWrapperProps>`
  position: relative;
  margin-top: -1px;
  margin-left: -${props => props.inset}px;
  margin-right: -${props => props.inset}px;
`;

const InnerWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
`;
